import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { FullPageLoader } from 'common';
import { AuthLayout } from 'components/layouts';

import { ROUTE } from 'constants/routes';
import { useCurrentUser } from 'hooks/user';

type Props = React.PropsWithChildren<unknown>;

export const AuthRoute = ({ children }: Props): JSX.Element => {
  const { currentUser, loading } = useCurrentUser();

  if (loading) return <FullPageLoader />;
  if (currentUser) return <Navigate to={ROUTE.Dashboard.path} />;

  return <AuthLayout>{children}</AuthLayout>;
};

export const ProtectedRoute = ({ children }: Props): JSX.Element => {
  const location = useLocation();
  const { currentUser, loading } = useCurrentUser();

  if (loading) return <FullPageLoader />;
  if (!currentUser) return <Navigate to={ROUTE.Login.path} />;
  if (location.pathname === '/') return <Navigate to={ROUTE.Dashboard.path} />;

  return children as JSX.Element;
};
